export class SpeakerModel {
  // Speaker Fields
  id;
  alias;
  session_device_id;
  user_id;
  binding_method;
  binding_confidence;
  fingerprinted;

  static fromJson(json) {
    const model = new SpeakerModel();
    model.id = json["id"];
    model.alias = json["alias"];
    model.session_device_id = json["session_device_id"];
    // CS330: preserve user_id + binding fields so the recorder browser's
    // auto-push useEffect can identify which Speakers are bound to a
    // logged-in student account and need their persisted voiceprint pushed.
    // Without these, the auto-push filter `s.user_id != null` matches
    // nothing — every student lands on "Setting up your voice…" forever.
    model.user_id = json["user_id"] != null ? json["user_id"] : null;
    model.binding_method = json["binding_method"] || null;
    model.binding_confidence = json["binding_confidence"] != null ? json["binding_confidence"] : null;
    model.fingerprinted = false;
    return model;
  }

  // Converts JSON to SpeakerListModel[]
  static fromJsonList(jsonArray) {
    const speakers = [];
    for (const el of jsonArray) {
      speakers.push(SpeakerModel.fromJson(el));
    }
    return speakers;
  }
}
